jQuery(function ($) {
  console.log("spektrix quick add loaded");

  // Use global basket manager if available, fallback to local implementation
  function getBasketData() {
    if (window.BasketManager) {
      return window.BasketManager.get();
    }
    
    // Fallback for cases where global manager isn't loaded yet
    return jQuery.ajax({
      url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket",
      type: "GET",
      xhrFields: {
        withCredentials: true,
      },
    });
  }

  function refreshBasketData() {
    if (window.BasketManager) {
      return window.BasketManager.refresh();
    }
    
    return getBasketData();
  }

  function countTicketsInBasket(basketData) {
    var ticketCounts = {};
    if (basketData && basketData.tickets) {
      basketData.tickets.forEach(function (ticket) {
        // Create key in the format that matches our select names
        var key =
          ticket.instance.id + "|" + ticket.planId + "|" + ticket.type.id;
        ticketCounts[key] = (ticketCounts[key] || 0) + 1;
      });
    }
    console.log("Ticket counts from basket:", ticketCounts);
    return ticketCounts;
  }

  function countPassesInBasket(basketData) {
    var passCounts = {};
    if (basketData && basketData.ticketSubscriptions) {
      basketData.ticketSubscriptions.forEach(function (subscription) {
        // Create key using the pricingSetName directly since server handles the mapping
        var key = subscription.pricingSetName;
        passCounts[key] = (passCounts[key] || 0) + 1;
      });
    }
    console.log("Pass counts from basket:", passCounts);
    return passCounts;
  }

  function countMembershipsInBasket(basketData) {
    var membershipCounts = {};
    if (basketData && basketData.membershipSubscriptions) {
      basketData.membershipSubscriptions.forEach(function (subscription) {
        // Track by membership ID - membership is nested in subscription object
        var key = subscription.membership && subscription.membership.id;
        if (key) {
          membershipCounts[key] = true;
        }
      });
    }
    console.log("Membership counts from basket:", membershipCounts);
    return membershipCounts;
  }

  function countReservedSeatsByInstance(basketData) {
    var instanceCounts = {};
    if (basketData && basketData.tickets) {
      basketData.tickets.forEach(function (ticket) {
        var instanceId = ticket.instance.id;
        instanceCounts[instanceId] = (instanceCounts[instanceId] || 0) + 1;
      });
    }
    console.log("Reserved seat counts by instance:", instanceCounts);
    return instanceCounts;
  }

  // A best-available quick-add's tickets in the cart (inc/quick-add.php's
  // best[instance]): by section, as best-available tickets carry their
  // seating area's plan rather than the instance's.
  function bestTickets(basketData, instanceId, bandId) {
    return ((basketData && basketData.tickets) || []).filter(function (ticket) {
      return ticket.instance.id === instanceId && (!bandId || (ticket.band && ticket.band.id === bandId));
    });
  }

  function bestInstance(select) {
    var matches = select.name.match(/^best\[(.*?)\]$/);
    return matches ? matches[1] : null;
  }

  function bestBand($form, instanceId) {
    return $form.find('[name="band[' + instanceId + ']"]');
  }

  function populateExistingQuantities($form, ticketCounts, passCounts, membershipCounts, basketData) {
    var hasExistingItems = false;

    // Best-available seats: the count shown is the chosen section's, and a
    // section with seats in the cart is chosen over the dearest.
    $form.find('select[name^="best["]').each(function () {
      var $select = $(this);
      var instanceId = bestInstance(this);
      var $band = bestBand($form, instanceId);
      var counts = {};
      bestTickets(basketData, instanceId).forEach(function (ticket) {
        var bandId = ticket.band ? ticket.band.id : "";
        counts[bandId] = (counts[bandId] || 0) + 1;
        hasExistingItems = true;
      });
      $select.data("bandCounts", counts);
      if ($band.is("select")) {
        var $held = $band.find("option").filter(function () {
          return counts[this.value] > 0;
        });
        if ($held.length) $band.val($held.first().val());
      }
      var count = counts[$band.val()] || 0;
      $select.val(count).attr("data-original-count", count);

      // Get Tickets, which opens this form's pop-up, and its copies (the
      // Shortlist's): the seats in the cart, picked by either way.
      var held = bestTickets(basketData, instanceId).length;
      $('[data-quick-add-open="' + instanceId + '"]').text(
        held ? held + (held === 1 ? " Seat" : " Seats") + " in Cart" : "Get Tickets"
      );
    });

    // Handle tickets (both selects and hidden inputs)
    $form.find('select[name^="tickets["], input[type="hidden"][name^="tickets["]').each(function () {
      var $element = $(this);
      var name = $element.attr("name");

      // Parse structured naming: tickets[instance][plan][type]
      var matches = name.match(/tickets\[(.*?)\]\[(.*?)\]\[(.*?)\]/);
      if (matches) {
        var key = matches[1] + "|" + matches[2] + "|" + matches[3];
        var existingCount = ticketCounts[key] || 0;

        // Only update value for selects, not hidden inputs (preserve their preset values)
        if ($element.is('select')) {
          $element.val(existingCount);
        }

        $element.attr("data-original-count", existingCount);
        console.log("Set ticket element", name, "original count to", existingCount);

        if (existingCount > 0) {
          hasExistingItems = true;
        }
      }
    });

    // Handle passes
    $form.find('select[name^="passes["]').each(function () {
      var $select = $(this);
      var name = $select.attr("name");

      // Parse structured naming: passes[pricingSetId][pricingSetName]
      var matches = name.match(/passes\[(.*?)\]\[(.*?)\]/);
      if (matches) {
        var pricingSetId = matches[1];
        var pricingSetName = matches[2];
        var existingCount = passCounts[pricingSetName] || 0;
        $select.attr("data-original-count", existingCount);
        console.log("Set pass select", name, "to", existingCount, "original count");

        if (passCounts[pricingSetName] > 0) {
          $select.val(existingCount);
          hasExistingItems = true;
        }
      }
    });

    // Handle memberships (both checkboxes and hidden inputs)
    $form.find('input[name^="memberships["]').each(function () {
      var $input = $(this);
      var name = $input.attr("name");
      var isHidden = $input.attr("type") === "hidden";

      // Parse structured naming: memberships[membershipId]
      var matches = name.match(/memberships\[(.*?)\]/);
      if (matches) {
        var membershipId = matches[1];
        var isInBasket = membershipCounts[membershipId] || false;

        if (isHidden) {
          // For hidden inputs, set data-original-count based on basket (0 or 1)
          // Don't modify the value, preserve what's in HTML
          $input.attr("data-original-count", isInBasket ? "1" : "0");
          console.log("Set membership hidden input", name, "original count:", isInBasket ? 1 : 0, "current value:", $input.val());
        } else {
          // For checkboxes, only update state if not already checked
          // This preserves pre-checked state from HTML (e.g., for addAll mode)
          if (!$input.is(':checked')) {
            $input.prop('checked', isInBasket);
          }

          $input.attr("data-original-state", isInBasket ? "1" : "0");
          console.log("Set membership checkbox", name, "original state:", isInBasket, "current checked:", $input.is(':checked'));
        }

        if (isInBasket) {
          hasExistingItems = true;
        }
      }
    });

    // Handle reserved seating tickets (both selects and hidden inputs)
    $form.find('select[name^="reserved["], input[type="hidden"][name^="reserved["]').each(function () {
      var $element = $(this);
      var name = $element.attr("name");

      // Parse structured naming: reserved[instance][priceBand]
      var matches = name.match(/reserved\[(.*?)\]\[(.*?)\]/);
      if (matches) {
        // Reserved tickets are always new, set original count to 0
        // Don't modify the value for either selects or hidden inputs
        $element.attr("data-original-count", "0");
        console.log("Set reserved ticket element", name, "original count to 0, current value:", $element.val());
      }
    });

    // Handle reserved seating buttons
    if (basketData) {
      var instanceCounts = countReservedSeatsByInstance(basketData);

      // Handle buttons with data-instance-id (preferred). Not best-available's
      // "Choose your seats": its stepper shows the count.
      $form.find('a[data-instance-id]').not('.quick-add-seats').each(function () {
        var $button = $(this);
        var instanceId = $button.attr('data-instance-id');
        var seatCount = instanceCounts[instanceId] || 0;

        if (seatCount > 0) {
          $button.text(seatCount + (seatCount === 1 ? ' Seat Booked - Update' : ' Seats Booked - Update'));
          hasExistingItems = true;
          console.log("Updated Choose Seats button for instance", instanceId, "to show", seatCount, "seats");
        } else {
          $button.text('Choose Seats');
          console.log("Reset Choose Seats button for instance", instanceId, "to default text");
        }
      });
    }

    // Update button text based on whether user has existing items
    updateSubmitButtonText($form, hasExistingItems);
    syncQuickAddButtons($form);
  }

  // A quick-add's Add to Cart and Quick Buy wait for a quantity
  // (inc/quick-add.php renders them aria-disabled): Add to Cart (Update
  // Cart) once one is chosen or the cart has some to change, Quick Buy once
  // one is chosen. aria-disabled rather than disabled, which is for while
  // they're busy (and which the Shortlist's older widget reads as busy).
  function syncQuickAddButtons($form) {
    var selects = $form.find('select[name^="tickets["], select[name^="best["]').toArray();
    if (!selects.length) return;
    var chosen = selects.some(function (select) { return parseInt(select.value) > 0; });
    var held = selects.some(function (select) { return parseInt(select.getAttribute("data-original-count")) > 0; });
    $form.find(".quick-add-submit").attr("aria-disabled", String(!(chosen || held)));
    $form.find("[data-instant-buy]").attr("aria-disabled", String(!chosen));
  }

  function waitsForQuantity(button) {
    return button.getAttribute("aria-disabled") === "true";
  }
  
  function updateSubmitButtonText($form, hasExistingTickets) {
    var $submitButton = $form.find('button[type="submit"], button.push_button');
    if ($submitButton.length) {
      var customAddText = $submitButton.attr('data-add-text');
      var customUpdateText = $submitButton.attr('data-update-text');
      var addText = customAddText || "Add to Cart";
      var updateText = customUpdateText || "Update Cart";
      var buttonText = hasExistingTickets ? updateText : addText;
      $submitButton.text(buttonText);
      console.log("Updated button text to:", buttonText);
    }

    // Handle already-in-cart warning
    var $warningDiv = $form.find('[data-already-in-cart]');
    if ($warningDiv.length) {
      if (hasExistingTickets) {
        $warningDiv.html(
          'You already have items in the cart, you can try adding this item but be aware there could be a conflict or items added more than once. ' +
          'You can also <a href="#" class="clear-cart-link" style="text-decoration: underline;">click here to clear your cart</a>.'
        ).show();

        // Set up clear cart handler (remove old handlers first to avoid duplicates)
        $warningDiv.find('.clear-cart-link').off('click').on('click', function(e) {
          e.preventDefault();

          if (!confirm('Are you sure you want to clear your entire cart?')) {
            return;
          }

          console.log('Clearing cart...');

          jQuery.ajax({
            url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/clear",
            type: "POST",
            xhrFields: {
              withCredentials: true
            }
          })
          .then(function(response) {
            console.log('Cart cleared successfully', response);

            // Refresh basket data and update all forms
            return refreshBasketData().then(function(refreshedData) {
              console.log("Refreshed basket after clear:", refreshedData);

              var ticketCounts = countTicketsInBasket(refreshedData);
              var passCounts = countPassesInBasket(refreshedData);
              var membershipCounts = countMembershipsInBasket(refreshedData);

              $('.tickets-form').each(function() {
                populateExistingQuantities($(this), ticketCounts, passCounts, membershipCounts, refreshedData);
              });

              // Update cart count in navigation
              var totalItems = window.BasketManager ? window.BasketManager.getCount(refreshedData) : 0;
              if (window.updateCartCount) {
                window.updateCartCount(totalItems, true);
              }
            });
          })
          .catch(function(error) {
            console.error('Error clearing cart:', error);
            alert('Error clearing cart. Please try again.');
          });
        });
      } else {
        $warningDiv.hide();
      }
    }
  }

  // Shared function to process form selects and determine cart operations
  function processFormSelects($form, basketData) {
    var ticketsToAdd = [];
    var ticketsToRemove = [];
    var passesToAdd = [];
    var passesToRemove = [];
    var membershipsToAdd = [];
    var membershipsToRemove = [];
    var hasChanges = false;

    // Process tickets from this form (both selects and hidden inputs)
    $form.find('select[name^="tickets["], input[type="hidden"][name^="tickets["]').each(function () {
      var $element = $(this);
      var name = $element.attr("name");
      var isHidden = $element.attr("type") === "hidden";

      var originalCount = parseInt($element.attr("data-original-count")) || 0;
      var newCount = parseInt($element.val()) || 0;
      var difference = newCount - originalCount;

      if (difference === 0) return;
      hasChanges = true;

      console.log(
        "Processing ticket " + (isHidden ? "hidden input" : "select") + ":",
        name,
        "Original:",
        originalCount,
        "New:",
        newCount,
        "Difference:",
        difference,
      );

      // Parse structured naming: tickets[instance][plan][type]
      var matches = name.match(/tickets\[(.*?)\]\[(.*?)\]\[(.*?)\]/);
      if (!matches) {
        console.log("Warning: Could not parse ticket element name:", name);
        return;
      }

      var instanceId = matches[1];
      var planId = matches[2];
      var typeId = matches[3];

      if (difference > 0) {
        // Add tickets
        for (var i = 0; i < difference; i++) {
          ticketsToAdd.push({
            instance: instanceId,
            seatingPlan: planId,
            type: typeId,
          });
        }
      } else if (difference < 0) {
        // Remove tickets
        if (basketData && basketData.tickets) {
          var ticketsToRemoveForThisSelect = basketData.tickets
            .filter(function (ticket) {
              return (
                ticket.instance.id === instanceId &&
                ticket.planId === planId &&
                ticket.type.id === typeId
              );
            })
            .slice(0, Math.abs(difference));

          ticketsToRemoveForThisSelect.forEach(function (ticket) {
            ticketsToRemove.push(ticket.id);
          });
        }
      }
    });

    // Process passes from this form
    $form.find('select[name^="passes["]').each(function () {
      var $select = $(this);
      var name = $select.attr("name");
      var originalCount = parseInt($select.attr("data-original-count")) || 0;
      var newCount = parseInt($select.val()) || 0;
      var difference = newCount - originalCount;

      if (difference === 0) return;
      hasChanges = true;

      console.log(
        "Processing pass select:",
        name,
        "Original:",
        originalCount,
        "New:",
        newCount,
        "Difference:",
        difference,
      );

      // Parse structured naming: passes[pricingSetId][pricingSetName]
      var matches = name.match(/passes\[(.*?)\]\[(.*?)\]/);
      if (!matches) {
        console.log("Warning: Could not parse pass select name:", name);
        return;
      }

      var pricingSetId = matches[1];
      var pricingSetName = matches[2];

      if (difference > 0) {
        // Add passes - API expects array of objects with pricingSetId and quantity
        passesToAdd.push({
          pricingSetId: pricingSetId,
          quantity: difference
        });
      } else if (difference < 0) {
        // Remove passes
        if (basketData && basketData.ticketSubscriptions) {
          var passesToRemoveForThisSelect = basketData.ticketSubscriptions
            .filter(function (subscription) {
              return subscription.pricingSetName === pricingSetName;
            })
            .slice(0, Math.abs(difference));

          passesToRemoveForThisSelect.forEach(function (subscription) {
            passesToRemove.push(subscription.id);
          });
        }
      }
    });

    // Process reserved seating tickets from this form (both selects and hidden inputs)
    var reservedToAdd = [];
    $form.find('select[name^="reserved["], input[type="hidden"][name^="reserved["]').each(function () {
      var $element = $(this);
      var name = $element.attr("name");
      var originalCount = parseInt($element.attr("data-original-count")) || 0;
      var newCount = parseInt($element.val()) || 0;
      var difference = newCount - originalCount;

      if (difference === 0) return;
      hasChanges = true;

      console.log(
        "Processing reserved ticket element:",
        name,
        "Original:",
        originalCount,
        "New:",
        newCount,
        "Difference:",
        difference,
      );

      // Parse structured naming: reserved[instance][priceBand]
      // Get priceBand from: https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/instances/{instanceId}/price-list
      var matches = name.match(/reserved\[(.*?)\]\[(.*?)\]/);
      if (!matches) {
        console.log("Warning: Could not parse reserved ticket element name:", name);
        return;
      }

      var instanceId = matches[1];
      var priceBandId = matches[2];

      if (difference > 0) {
        // Add reserved tickets via best-available endpoint
        reservedToAdd.push({
          instance: instanceId,
          priceBand: priceBandId,
          quantity: difference
        });
      }
      // Note: Removal of reserved tickets would use regular ticket removal (if needed in future)
    });

    // Best-available seats (inc/quick-add.php's best[instance], in the
    // section band[instance]): the cart ends up with that many there. More
    // asks for the whole party's seats again, so they sit together, and
    // lets the old ones go (executeCartUpdates); fewer lets the last go.
    $form.find('select[name^="best["]').each(function () {
      var instanceId = bestInstance(this);
      var bandId = bestBand($form, instanceId).val();
      var originalCount = parseInt(this.getAttribute("data-original-count")) || 0;
      var newCount = parseInt(this.value) || 0;
      if (!instanceId || !bandId || newCount === originalCount) return;
      hasChanges = true;

      var held = bestTickets(basketData, instanceId, bandId);
      if (newCount > held.length) {
        reservedToAdd.push({
          instance: instanceId,
          priceBand: bandId,
          quantity: newCount,
          added: newCount - held.length,
          replace: held.map(function (ticket) { return ticket.id; }),
        });
      } else {
        held.slice(newCount).forEach(function (ticket) {
          ticketsToRemove.push(ticket.id);
        });
      }
    });

    // Process memberships from this form (both checkboxes and hidden inputs)
    $form.find('input[name^="memberships["]').each(function () {
      var $input = $(this);
      var name = $input.attr("name");
      var isHidden = $input.attr("type") === "hidden";

      var originalState, newState;

      if (isHidden) {
        // For hidden inputs, check if value > 0
        originalState = parseInt($input.attr("data-original-count")) || 0;
        newState = parseInt($input.val()) || 0;

        if (originalState === newState) return;
        hasChanges = true;

        console.log(
          "Processing membership hidden input:",
          name,
          "Original:",
          originalState,
          "New:",
          newState,
        );
      } else {
        // For checkboxes, check checked state
        originalState = $input.attr("data-original-state") === "1";
        newState = $input.is(':checked');

        if (originalState === newState) return;
        hasChanges = true;

        console.log(
          "Processing membership checkbox:",
          name,
          "Original:",
          originalState,
          "New:",
          newState,
        );
      }

      // Parse structured naming: memberships[membershipId]
      var matches = name.match(/memberships\[(.*?)\]/);
      if (!matches) {
        console.log("Warning: Could not parse membership input name:", name);
        return;
      }

      var membershipId = matches[1];

      // For both hidden and checkbox: if new value is truthy and original was falsy, add it
      if ((newState && !originalState) || (isHidden && newState > originalState)) {
        // Add membership - API expects array of objects with membership property
        membershipsToAdd.push({
          membership: membershipId
        });
      } else if ((!newState && originalState) || (isHidden && newState < originalState)) {
        // Remove membership
        if (basketData && basketData.membershipSubscriptions) {
          var membershipToRemove = basketData.membershipSubscriptions.find(function (subscription) {
            return (subscription.membership && subscription.membership.id === membershipId);
          });

          if (membershipToRemove) {
            // Use the subscription ID (not the membership ID) for deletion
            membershipsToRemove.push(membershipToRemove.id);
          }
        }
      }
    });

    return {
      ticketsToAdd: ticketsToAdd,
      ticketsToRemove: ticketsToRemove,
      passesToAdd: passesToAdd,
      passesToRemove: passesToRemove,
      membershipsToAdd: membershipsToAdd,
      membershipsToRemove: membershipsToRemove,
      reservedToAdd: reservedToAdd,
      hasChanges: hasChanges
    };
  }

  // The best seats left in a section (docs/best-available.md). Resolves
  // with the tickets, seat names and all.
  function bestAvailable(instanceId, bandId, quantity) {
    return jQuery.ajax({
      url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/tickets/best-available",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        instance: instanceId,
        priceBands: [bandId],
        quantity: quantity,
      }),
      xhrFields: {
        withCredentials: true,
      },
    });
  }

  // The ids go in unencoded, comma-separated (CLAUDE.md).
  function removeTickets(ticketIds) {
    return jQuery.ajax({
      url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/tickets?ticketIds=" + ticketIds.join(","),
      type: "DELETE",
      xhrFields: {
        withCredentials: true,
      },
    });
  }

  // Shared function to execute cart update API calls
  function executeCartUpdates(ticketsToAdd, ticketsToRemove, passesToAdd, passesToRemove, membershipsToAdd, membershipsToRemove, reservedToAdd) {
    var promises = [];

    console.log("Final tickets to add:", ticketsToAdd);
    console.log("Final tickets to remove:", ticketsToRemove);
    console.log("Final passes to add:", passesToAdd);
    console.log("Final passes to remove:", passesToRemove);
    console.log("Final memberships to add:", membershipsToAdd);
    console.log("Final memberships to remove:", membershipsToRemove);
    console.log("Final reserved tickets to add:", reservedToAdd);

    // jQuery.ajax({
    //   url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/tickets/best-available",
    //   type: "POST",
    //   contentType: "application/json",
    //   data: JSON.stringify({
    //     "instance": "1801APGQPRKNVLCHGSKJBCTJKDRMGPLNL",
    //     "quantity": 2
    //   }),
    //   xhrFields: {
    //     withCredentials: true,
    //   },
    // })

    if (ticketsToAdd.length > 0) {
      console.log("Making ADD request for", ticketsToAdd.length, "tickets");
      promises.push(
        jQuery.ajax({
          url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/tickets",
          type: "POST",
          contentType: "application/json",
          data: JSON.stringify(ticketsToAdd),
          xhrFields: {
            withCredentials: true,
          },
        }),
      );
    }

    if (ticketsToRemove.length > 0) {
      console.log(
        "Making DELETE request for",
        ticketsToRemove.length,
        "tickets",
      );

      // Build URL with ticketIds as comma-separated values (don't encode commas)
      var deleteUrl =
        "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/tickets";
      var ticketIdsList = ticketsToRemove.join(",");
      deleteUrl += "?ticketIds=" + ticketIdsList;

      console.log("DELETE URL:", deleteUrl);

      promises.push(
        jQuery.ajax({
          url: deleteUrl,
          type: "DELETE",
          xhrFields: {
            withCredentials: true,
          },
        }),
      );
    }

    if (passesToAdd.length > 0) {
      console.log("Making ADD request for", passesToAdd.length, "pass(es)");
      promises.push(
        jQuery.ajax({
          url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/ticket-subscriptions",
          type: "POST",
          contentType: "application/json",
          data: JSON.stringify(passesToAdd),
          xhrFields: {
            withCredentials: true,
          },
        }),
      );
    }

    if (passesToRemove.length > 0) {
      console.log(
        "Making DELETE request for",
        passesToRemove.length,
        "pass(es)",
      );

      // Make individual DELETE requests for each pass ID
      passesToRemove.forEach(function(passId) {
        var deletePassUrl =
          "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/ticket-subscriptions/" + passId;

        console.log("DELETE Pass URL:", deletePassUrl);

        promises.push(
          jQuery.ajax({
            url: deletePassUrl,
            type: "DELETE",
            xhrFields: {
              withCredentials: true,
            },
          }),
        );
      });
    }

    if (membershipsToAdd.length > 0) {
      console.log("Making ADD request for", membershipsToAdd.length, "membership(s)");
      promises.push(
        jQuery.ajax({
          url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/membership-subscriptions",
          type: "POST",
          contentType: "application/json",
          data: JSON.stringify(membershipsToAdd),
          xhrFields: {
            withCredentials: true,
          },
        }),
      );
    }

    if (membershipsToRemove.length > 0) {
      console.log(
        "Making DELETE request for",
        membershipsToRemove.length,
        "membership(s)",
      );

      // Make individual DELETE requests for each membership ID
      membershipsToRemove.forEach(function(membershipId) {
        var deleteMembershipUrl =
          "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/membership-subscriptions/" + membershipId;

        console.log("DELETE Membership URL:", deleteMembershipUrl);

        promises.push(
          jQuery.ajax({
            url: deleteMembershipUrl,
            type: "DELETE",
            xhrFields: {
              withCredentials: true,
            },
          }),
        );
      });
    }

    if (reservedToAdd.length > 0) {
      console.log("Making ADD request for", reservedToAdd.length, "reserved ticket(s) via best-available");

      // Make individual POST requests for each reserved ticket group
      reservedToAdd.forEach(function(reservedTicket) {
        console.log("POST best-available:", reservedTicket);

        var replace = reservedTicket.replace || [];
        var seats = bestAvailable(reservedTicket.instance, reservedTicket.priceBand, reservedTicket.quantity);
        if (replace.length) {
          // Seats for the whole party, then the ones held go. If Spektrix
          // can't seat them all together, the extra seats on their own.
          seats = Promise.resolve(seats).then(
            function (tickets) {
              return Promise.resolve(removeTickets(replace)).then(function () {
                return tickets;
              });
            },
            function () {
              return bestAvailable(reservedTicket.instance, reservedTicket.priceBand, reservedTicket.added);
            },
          );
        }
        promises.push(seats);
      });
    }

    if (promises.length === 0) {
      console.log("No changes to make");
      return Promise.resolve([]); // Return resolved promise with empty array
    }

    console.log("Executing", promises.length, "API request(s)");
    return Promise.all(promises);
  }

  // Shared function to build success message: what changed ("2 tickets
  // added."), with the cart link on the line below (cartLink()).
  function buildSuccessMessage(ticketsToAdd, ticketsToRemove, passesToAdd, passesToRemove, membershipsToAdd, membershipsToRemove, reservedToAdd) {
    var message = "";

    if (ticketsToAdd.length > 0) {
      message += ticketsToAdd.length + (ticketsToAdd.length === 1 ? " ticket" : " tickets") + " added. ";
    }
    if (ticketsToRemove.length > 0) {
      message += ticketsToRemove.length + (ticketsToRemove.length === 1 ? " ticket" : " tickets") + " removed. ";
    }
    if (passesToAdd.length > 0) {
      var totalPassQuantity = passesToAdd.reduce(function(sum, pass) {
        return sum + pass.quantity;
      }, 0);
      message += totalPassQuantity + (totalPassQuantity === 1 ? " pass" : " passes") + " added. ";
    }
    if (passesToRemove.length > 0) {
      message += passesToRemove.length + (passesToRemove.length === 1 ? " pass" : " passes") + " removed. ";
    }
    if (membershipsToAdd.length > 0) {
      message += membershipsToAdd.length + (membershipsToAdd.length === 1 ? " membership" : " memberships") + " added. ";
    }
    if (membershipsToRemove.length > 0) {
      message += membershipsToRemove.length + (membershipsToRemove.length === 1 ? " membership" : " memberships") + " removed. ";
    }
    if (reservedToAdd.length > 0) {
      var totalReservedQuantity = reservedToAdd.reduce(function(sum, reserved) {
        return sum + (reserved.added || reserved.quantity);
      }, 0);
      message += totalReservedQuantity + (totalReservedQuantity === 1 ? " seat" : " seats") + " added. ";
    }

    return message;
  }

  function cartLink() {
    return '<br><a href="/ticketing/cart/">Go to cart &amp; checkout &rarr;</a>';
  }

  // One-Click Buy's button (scripts.js opens it), when push-donations turns
  // it on: it checks out the cart in a pop-up (docs/one-click-buy.md).
  function oneClickBuyButton() {
    return window.PUSH_ONE_CLICK_BUY
      ? ' <button type="button" class="button small" data-one-click-buy>Quick Buy</button>'
      : "";
  }

  // Shared function to refresh forms after cart update
  function refreshFormsAfterUpdate(data, $formsToUpdate) {
    return refreshBasketData().then(function(refreshedData) {
      console.log("Updated basket:", refreshedData);
      var ticketCounts = countTicketsInBasket(refreshedData);
      var passCounts = countPassesInBasket(refreshedData);
      var membershipCounts = countMembershipsInBasket(refreshedData);

      $formsToUpdate.each(function() {
        var $form = $(this);
        populateExistingQuantities($form, ticketCounts, passCounts, membershipCounts, refreshedData);
      });

      // Update cart count in navigation with animation
      var totalItems = window.BasketManager ? window.BasketManager.getCount(refreshedData) : 0;
      if (window.updateCartCount) {
        window.updateCartCount(totalItems, true);
      }

      return refreshedData;
    });
  }

  // Shared function to show no changes message
  function showNoChangesMessage($targetElement) {
    $targetElement.find ? 
      $targetElement.find(".success, .info, .error").remove() :
      $targetElement.siblings(".success, .info, .error").remove();
    
    var $message = $('<p class="info" style="text-align: center; margin: 1rem 0;">No changes made to your cart.</p>');
    
    if ($targetElement.find) {
      // Form element - append inside
      $targetElement.append($message);
    } else {
      // Button element - insert after
      $targetElement.after($message);
    }
    
    setTimeout(function() { 
      $message.fadeOut(); 
    }, 3000);
  }

  // A quick-add's online sales close at its data-sale-end (inc/quick-add.php),
  // which a cached page can outlive: from then it says Not on sale, as a
  // fresh page would, and so does the Shortlist, which reads the same form.
  // Runs on each container initSpektrixForms() gets and again when the next
  // close comes. Returns whether any quick-add in scope has closed.
  var saleEndTimer = null;
  var nextSaleEnd = Infinity;
  function closeEndedSales(scope) {
    var now = Date.now();
    var closed = false;
    var $scope = $(scope || document);
    $scope.find(".quick-add[data-sale-end]").addBack(".quick-add[data-sale-end]").each(function () {
      var end = Date.parse(this.getAttribute("data-sale-end"));
      if (isNaN(end)) return;
      if (end > now) {
        if (end < nextSaleEnd) {
          nextSaleEnd = end;
          clearTimeout(saleEndTimer);
          // setTimeout holds at most about 24 days.
          saleEndTimer = setTimeout(function () {
            nextSaleEnd = Infinity;
            closeEndedSales();
          }, Math.min(end - now + 1000, 2147483647));
        }
        return;
      }
      closed = true;
      var $quickAdd = $(this).removeAttr("data-sale-end");
      $quickAdd.children(".quick-add-controls, .quick-add-open, .quick-add-dialog, .success, .info, .error").remove();
      $quickAdd.append('<span class="quick-add-status">Not on sale</span>');
    });
    return closed;
  }

  // Shared function to handle cart errors
  function handleCartError(error, $targetElement) {
    console.error("Error updating cart:", error);
    
    $targetElement.find ? 
      $targetElement.find(".success, .info, .error").remove() :
      $targetElement.siblings(".success, .info, .error").remove();
    
    // Spektrix refuses tickets it can't sell (4xx): most likely sold out,
    // fewer left than asked for, or online sales just closed.
    var status = error && typeof error.status === "number" ? error.status : null;
    var text = "Please try again or clear cart and try again.";
    if (closeEndedSales($targetElement)) {
      text = "Online sales for this showtime have closed.";
    } else if (status === 0 && navigator.onLine === false) {
      text = "Couldn\u2019t reach the box office. Check your connection and try again.";
    } else if (status === 0 || (status >= 400 && status < 500)) {
      // 0 online: Spektrix's error responses (a 500, say) carry no CORS
      // headers, so the browser hides them. Most likely a refusal.
      text = "These tickets couldn\u2019t be added: the showtime may have sold out, or have fewer tickets left than you chose.";
    } else if (status >= 500) {
      text = "The box office didn\u2019t respond. Please try again in a moment.";
    }
    var $errorMessage = $('<p class="error" style="text-align: center; margin: 1rem 0; color: red;"></p>').text(text);
    
    if ($targetElement.find) {
      // Form element - append inside
      $targetElement.append($errorMessage);
    } else {
      // Button element - insert after
      $targetElement.after($errorMessage);
    }
  }

  // Global function for Add All to Cart functionality
  window.submitAllForms = function() {
    console.log('Submit All Forms triggered');

    var allTicketsToAdd = [];
    var allTicketsToRemove = [];
    var allPassesToAdd = [];
    var allPassesToRemove = [];
    var allMembershipsToAdd = [];
    var allMembershipsToRemove = [];
    var allReservedToAdd = [];
    var hasAnyChanges = false;

    // Get current basket data once
    var basketData = window.BasketManager ? window.BasketManager.data : null;

    // Add All belongs to the underlying page, not a show opened for review.
    $('.tickets-form').not('shortlist-widget .tickets-form').each(function() {
      var $form = $(this);
      var formChanges = processFormSelects($form, basketData);

      if (formChanges.hasChanges) {
        hasAnyChanges = true;

        // Merge this form's changes into the aggregate arrays
        allTicketsToAdd = allTicketsToAdd.concat(formChanges.ticketsToAdd);
        allTicketsToRemove = allTicketsToRemove.concat(formChanges.ticketsToRemove);
        allPassesToAdd = allPassesToAdd.concat(formChanges.passesToAdd);
        allPassesToRemove = allPassesToRemove.concat(formChanges.passesToRemove);
        allMembershipsToAdd = allMembershipsToAdd.concat(formChanges.membershipsToAdd);
        allMembershipsToRemove = allMembershipsToRemove.concat(formChanges.membershipsToRemove);
        allReservedToAdd = allReservedToAdd.concat(formChanges.reservedToAdd);
      }
    });

    if (!hasAnyChanges) {
      showNoChangesMessage($('.add-all-button'));
      return;
    }

    console.log('Aggregated data:', {
      ticketsToAdd: allTicketsToAdd,
      ticketsToRemove: allTicketsToRemove,
      passesToAdd: allPassesToAdd,
      passesToRemove: allPassesToRemove,
      membershipsToAdd: allMembershipsToAdd,
      membershipsToRemove: allMembershipsToRemove,
      reservedToAdd: allReservedToAdd
    });

    // Disable button and show loading
    $('.add-all-button').prop('disabled', true).text('Processing...');

    // Execute all cart updates using shared function
    executeCartUpdates(allTicketsToAdd, allTicketsToRemove, allPassesToAdd, allPassesToRemove, allMembershipsToAdd, allMembershipsToRemove, allReservedToAdd)
      .then(function (responses) {
        console.log("Add All responses:", responses);

        // Build and display success message
        var message = buildSuccessMessage(allTicketsToAdd, allTicketsToRemove, allPassesToAdd, allPassesToRemove, allMembershipsToAdd, allMembershipsToRemove, allReservedToAdd);

        $('.add-all-button').after(
          '<p class="success" style="text-align: center; margin: 1rem 0; color: green; font-weight: bold;">' +
            message.trim() +
            cartLink() +
            oneClickBuyButton() +
            '</p>'
        );

        // Refresh all forms after update
        refreshFormsAfterUpdate(responses, $('.tickets-form'));

        $('.add-all-button').prop('disabled', false);

        // Update button text based on new basket contents
        if (window.updateAddAllButtonText) {
          window.updateAddAllButtonText();
        } else {
          // Fallback: determine button text based on updated basket
          var hasExistingItems = (basketData && basketData.tickets && basketData.tickets.length > 0) ||
                                (basketData && basketData.ticketSubscriptions && basketData.ticketSubscriptions.length > 0) ||
                                (basketData && basketData.membershipSubscriptions && basketData.membershipSubscriptions.length > 0);
          var buttonText = hasExistingItems ? "Update Cart" : "Add All to Cart";
          $('.add-all-button').text(buttonText);
        }
      })
      .catch(function (error) {
        $('.add-all-button').prop('disabled', false);
        handleCartError(error, $('.add-all-button'));

        // Update button text based on current basket contents even after error
        if (window.updateAddAllButtonText) {
          window.updateAddAllButtonText();
        } else {
          $('.add-all-button').text('Add All to Cart'); // fallback
        }
      });
  };

  // Initialize all spektrix forms within a container
  function initSpektrixForms(container) {
    container = container || document;
    closeEndedSales(container);
    
    $(container).find('.tickets-form').each(function () {
      var $form = $(this);
      
      // Skip if already initialized
      if ($form.data('spektrix-initialized')) {
        return;
      }
      $form.data('spektrix-initialized', true);
      
      var currentBasketData = null;

      // Use shared basket data to populate existing quantities
      getBasketData().then(function(basketData) {
        currentBasketData = basketData;
        var ticketCounts = countTicketsInBasket(basketData);
        var passCounts = countPassesInBasket(basketData);
        var membershipCounts = countMembershipsInBasket(basketData);
        populateExistingQuantities($form, ticketCounts, passCounts, membershipCounts, basketData);
      });

      // Choosing a section shows its seats in the cart. A first choice (none
      // in the cart in either) keeps the number chosen.
      $form.on("change", "select.quick-add-band", function () {
        var $quantity = $form.find('select[name="best[' + this.name.slice(5, -1) + ']"]');
        var counts = $quantity.data("bandCounts") || {};
        var held = counts[this.value] || 0;
        var wasHeld = parseInt($quantity.attr("data-original-count")) || 0;
        $quantity.attr("data-original-count", held);
        if (held || wasHeld) {
          $quantity.val(held);
          $quantity[0].dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      $form.on("change input", 'select[name^="tickets["], select[name^="best["]', function () {
        syncQuickAddButtons($form);
      });

      // Quick Buy (inc/quick-add.php): put the chosen tickets in the cart,
      // then check it out in One-Click Buy's pop-up (scripts.js).
      var $instantBuy = $form.find("[data-instant-buy]");
      $instantBuy.prop("hidden", !window.PUSH_ONE_CLICK_BUY);
      $instantBuy.on("click", function () {
        var button = this;
        if (waitsForQuantity(button)) return;

        var basketData = window.BasketManager ? window.BasketManager.data : currentBasketData;
        var changes = processFormSelects($form, basketData);
        $instantBuy.prop("disabled", true);
        var ready = changes.hasChanges
          ? executeCartUpdates(changes.ticketsToAdd, changes.ticketsToRemove,
                               changes.passesToAdd, changes.passesToRemove,
                               changes.membershipsToAdd, changes.membershipsToRemove,
                               changes.reservedToAdd)
              .then(function () {
                return refreshFormsAfterUpdate(null, $form);
              })
              .then(function (data) {
                currentBasketData = data;
              })
          : Promise.resolve();
        ready
          .then(function () {
            $form.find(".success, .info, .error").remove();
            // From the Get Tickets pop-up: it closes first (a modal dialog
            // would sit above One-Click Buy's), giving focus back to Get
            // Tickets, which One-Click Buy then returns to.
            var dialog = $form.closest("dialog")[0];
            var trigger = button;
            if (dialog && dialog.open) {
              dialog.close();
              trigger = document.activeElement !== document.body ? document.activeElement : null;
            }
            window.openOneClickBuy(trigger);
          })
          .catch(function (error) {
            handleCartError(error, $form);
          })
          .then(function () {
            $instantBuy.prop("disabled", false);
          });
      });

      // Skip individual form submission if in Add All mode
      $form.on("submit", function (e) {
        if (window.addAllMode && !$form.closest('shortlist-widget, .quick-add-dialog').length) {
          e.preventDefault();
          console.log('Individual form submission prevented in Add All mode');
          return false;
        }
        e.preventDefault();
        var $quickAddSubmit = $form.find(".quick-add-submit");
        if ($quickAddSubmit.length && waitsForQuantity($quickAddSubmit[0])) return;
        console.log("Form submitted");

        // Get current basket data
        var basketData = window.BasketManager ? window.BasketManager.data : currentBasketData;

        // Process form to determine changes
        var changes = processFormSelects($form, basketData);

        if (!changes.hasChanges) {
          showNoChangesMessage($form);
          return;
        }

        // Disable submit button and show loading state
        var $submitButton = $form.find('button[type="submit"], button.push_button');
        var originalButtonText = $submitButton.text();
        $submitButton.prop('disabled', true).text('Processing...');

        // Execute cart updates
        executeCartUpdates(changes.ticketsToAdd, changes.ticketsToRemove,
                          changes.passesToAdd, changes.passesToRemove,
                          changes.membershipsToAdd, changes.membershipsToRemove,
                          changes.reservedToAdd)
          .then(function (responses) {
            console.log("Update responses:", responses);

            // Check if form has redirect_to input
            var $redirectInput = $form.find('input[name="redirect_to"]');
            if ($redirectInput.length && $redirectInput.val()) {
              var redirectUrl = $redirectInput.val();
              console.log("Redirecting to:", redirectUrl);
              window.location.href = redirectUrl;
              return;
            }

            // Check if form has BYOT success message flag
            var $byotFlag = $form.find('input[name="byot_success_message"]');
            if ($byotFlag.length) {
              console.log("BYOT success message mode");

              // Remove the submit button
              $submitButton.remove();

              // Build custom BYOT success markup
              $form.find(".success, .info, .error").remove();
              if ($byotFlag.val() == 'byot' || $byotFlag.val() == 'subsidized') {
                $form.append(
                  '<p class="success" style="margin-top: 1rem;">Pass successfully added to cart.</p>' +
                  '<div class="passes-banner passes-banner-plain">' +
                    '<p><strong>Your ' + ($byotFlag.val() === 'byot' ? 'Build-Your-Own-Track Industry Pass' : 'Pass') + ' gives you 20% off individual show tickets.</strong> Discount applied at checkout.</p>' +
                    '<a href="/#program" class="button">Browse shows</a>' +
                    '<p style="margin: 15px 0 15px">Need more time to pick shows? No problem: Once you\'ve purchased your pass, simply sign in to your account and your 20% discount will apply at checkout.</p>' +
                    '<a href="/ticketing/cart/" class="button">Go to Cart</a>' +
                  '</div>'
                );
              }
              else {
                $form.append(
                  '<p class="success" style="margin-top: 1rem;">Pass successfully added to cart.</p>' +
                  '<div class="passes-banner passes-banner-plain">' +
                    '<p><strong>Check out now or Browse Shows to make the most of the festival.</strong></p>' +
                    '<a href="/#program" class="button">Browse shows</a>' +
                    '<p style="margin: 15px 0 15px">Need more time to pick shows? No problem: Once you\'ve purchased your pass, simply sign in to your account choose your shows and checkout.</p>' +
                    '<a href="/ticketing/cart/" class="button">Go to Cart</a>' +
                  '</div>'
                );
              }

              // Hide the already-in-cart warning for BYOT success
              $form.find('[data-already-in-cart]').hide();

              // Refresh basket data
              refreshFormsAfterUpdate(responses, $form).then(function(data) {
                currentBasketData = data;
                // Keep warning hidden even after refresh
                $form.find('[data-already-in-cart]').hide();
              });

              return;
            }

            // Build and display regular success message
            var message = buildSuccessMessage(changes.ticketsToAdd, changes.ticketsToRemove,
                                            changes.passesToAdd, changes.passesToRemove,
                                            changes.membershipsToAdd, changes.membershipsToRemove,
                                            changes.reservedToAdd);

            $form.find(".success, .info, .error").remove();
            $form.append(
              '<p class="success" style="margin-top: 1rem;">' +
                message.trim() +
                cartLink() +
                // A quick-add has its own Quick Buy beside Update Cart.
                ($instantBuy.length ? "" : oneClickBuyButton()) +
                '</p>',
            );

            // Refresh forms after update
            refreshFormsAfterUpdate(responses, $form).then(function(data) {
              currentBasketData = data;

              // Re-enable button - text will be updated by populateExistingQuantities
              $submitButton.prop('disabled', false);
            });
          })
          .catch(function (error) {
            // Re-enable button and restore original text on error
            $submitButton.prop('disabled', false).text(originalButtonText);
            handleCartError(error, $form);
          });
      });
    });
  }

  // A cart changed elsewhere, e.g. checked out by One-Click Buy
  // (js/one-click-buy/App.tsx), with the refreshed basket: the forms count
  // it again.
  document.addEventListener("push:basket", function (event) {
    var basketData = event.detail;
    var ticketCounts = countTicketsInBasket(basketData);
    var passCounts = countPassesInBasket(basketData);
    var membershipCounts = countMembershipsInBasket(basketData);
    $(".tickets-form").each(function () {
      var $form = $(this);
      $form.find(".success, .info, .error").remove();
      populateExistingQuantities($form, ticketCounts, passCounts, membershipCounts, basketData);
    });
  });

  // Initialize forms on page load
  initSpektrixForms();
  
  // Make function available for external modules
  window.initSpektrixForms = initSpektrixForms;
});
